import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class TheMoveToTopButton extends Vue {
  showGoToBtn = false;

  created() {
    window.addEventListener("scroll", this.scrolling);
    setTimeout(() => {
      this.isOnBottom();
    }, 1000);
  }
  destroyed() {
    window.removeEventListener("scroll", this.scrolling);
  }

  isOnBottom() {
    const bottomOfWindow =
      Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      ) +
        window.innerHeight >=
      document.documentElement.offsetHeight - 10;

    this.showGoToBtn = bottomOfWindow;
  }

  scrolling() {
    this.isOnBottom();
  }

  gotTop(e: any) {
    document.documentElement.scroll({
      top: 0,
      behavior: "smooth",
    });
  }
}
